import { render, staticRenderFns } from "./ReelModalSwitch.vue?vue&type=template&id=589a5f5a&scoped=true"
import script from "./ReelModalSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelModalSwitch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelModalSwitch.vue?vue&type=style&index=0&id=589a5f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a5f5a",
  null
  
)

export default component.exports